<script setup lang="ts">
import useModel from './../model/model'
import { useCabinetReports } from '@/pages/object/CabinetReports'
import { onBeforeMount, watch } from 'vue'
import { useSseConnection } from '@/shared/lib'
import { useRoute } from 'vue-router'

const { loadTable, headers, data, total } = useModel()
const model = useCabinetReports()
const route = useRoute()

const { isFetching, refetch } = loadTable(model.filter)

/* Устанавливаем SSE соединение */
const { handler } = useSseConnection(async () => refetch())

watch(
  () => route.params.object_id,
  () => {
    handler(`/cabinets/${route.params.object_id}/statuses`)
  },
  { immediate: true },
)

onBeforeMount(() => {
  model.filter.page = 1
  model.filter.per_page = 10
  model.setCallback(refetch)
})
</script>

<template>
  <VDataTableServer
    v-model:items-per-page="model.filter.per_page"
    v-model:page="model.filter.page"
    :loading="isFetching"
    :headers="headers"
    :items="data"
    :items-length="total"
    :items-per-page-options="model.perPageList"
    @update:options="refetch"
  >
    <template v-slot:item.index="{ index }">
      {{ index + 1 + model.filter.per_page * (model.filter.page - 1) }}
    </template>
  </VDataTableServer>
</template>
